import { configureStore } from "@reduxjs/toolkit";
import dashboard from "./slices/DashboardSlice/dashboard";
import AdminDashboard from "./slices/DashboardSlice/AdminDashboard";
import DepartmentList from './slices/master/department/DepartmentList'
import DesignationList from './slices/master/designation/DesignationList'
import UserList from './slices/user/UserList'
import DefectList from './slices/master/defects/DefectList'
import ConfigurationList from './slices/tooling-configuration/ConfigurationList'
import ConfigurationHistory from './slices/tooling-configuration/ConfigurationHistory'
import ActivityLogList from './slices/activity-log/ActivityLogList'
import VersionList from "./slices/master/version/VersionDetails";
import ReasonList from './slices/master/reason/ReasonList'
import GateList from './slices/master/gate/GateList'
import PurposeList from './slices/master/purpose/PurposeList'
import VisitorList from './slices/visitor/VisitorList'

const Store = configureStore({
  reducer: {
    Dashboard: dashboard,
    AdminDashboard: AdminDashboard,
    departmentList: DepartmentList,
    designationList: DesignationList,
    userList: UserList,
    defectList: DefectList,
    configurationHistory: ConfigurationHistory,
    configurationList: ConfigurationList,
    activityLogList: ActivityLogList,
    versionList: VersionList,
    reasonList: ReasonList,
    gateList: GateList,
    purposeList: PurposeList,
    visitorList: VisitorList,
  }
})
export default Store;